module.exports = new __parcel__URL__("dps_icon.35456f04.png").toString();